"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookie = /** @class */ (function () {
    function Cookie() {
    }
    Cookie.init = function () {
        var el = document.querySelector('.cookies');
        if (el) {
            if (localStorage.getItem('cookies') === 'yes') {
                el.remove();
            }
            else {
                el.classList.remove('hidden');
                el.addEventListener('click', function () {
                    localStorage.setItem('cookies', 'yes');
                    el.remove();
                });
            }
        }
    };
    return Cookie;
}());
exports.default = Cookie;
